<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-6">
          <h1 v-if="id">Edit Image for {{ titleName }}</h1>
          <h1 v-else>Add Image to {{ titleName }}</h1>
        </div>
        <div class="col-xs-6 mandatoryDiv">
          <span class="mandatory_color">(*)</span>
          <span class="letter-right"> Marked are required field</span>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="alert alert-info" v-if="alert_message">
            {{ alert_message }}
          </div>
        </div>
        <form @submit.prevent="formSubmit" ref="myForm">
          <div class="col-sm-12">
            <div class="box">
              <div class="box-header">
                <h3 class="box-title">Add Information</h3>
              </div>
              <div class="box-body form-box-body form-horizontal">
                <div class="form-group">
                  <label class="col-md-2 control-label"> Image </label>
                  <div class="col-md-4">
                    <input
                      type="text"
                      :disabled="id ? true : false"
                      v-model="formData.img"
                      id="img"
                      name="img"
                      placeholder="Enter Image Src URL"
                      class="form-control input-sm"
                      @focus="$event.target.removeAttribute('readonly')"
                      readonly
                    />
                  </div>
                  <label class="col-md-2 control-label">Onclick URL</label>
                  <div class="col-md-4">
                    <input
                      type="text"
                      :disabled="id ? true : false"
                      v-model="formData.onclick_link"
                      id="onclick_link"
                      name="onclick_link"
                      placeholder="Enter Destination URL"
                      class="form-control input-sm"
                      @focus="$event.target.removeAttribute('readonly')"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-md-2 control-label">Platform</label>
                  <div class="col-md-4">
                    <select
                      v-model="formData.device_type"
                      v-select="formData.device_type"
                      id="device_type"
                      name="device_type"
                      class="form-control input-sm select2"
                    >
                      <option value="" disabled selected>
                        Select Platform
                      </option>
                      <option value="1">Android</option>
                      <option value="2">iOS</option>
                      <option value="3">Windows</option>
                      <option value="4">MacOS</option>
                    </select>
                    <small v-if="errors.device_type" class="text-danger">{{
                      errors.device_type
                    }}</small>
                  </div>
                  <label class="col-md-2 control-label">Is Active</label>
                  <div class="col-md-4">
                    <input
                      type="checkbox"
                      v-model="formData.status"
                      value="1"
                      id="status"
                      name="status"
                      @change="errors.status && delete errors.status"
                    />
                    <small v-if="errors.status" class="text-danger">{{
                      errors.status
                    }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 btnCenter">
            <input
              type="submit"
              name="submit"
              value="Submit"
              class="btn btn-sm btn-submit btn-submit-big"
              @click="formSubmit"
            />
          </div>
        </form>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "AddBannerImage",
  data() {
    return {
      userData: {},
      alert_message: "",
      titleName: "",
      id: null,
      banner_id: this.$route.params.id,
      formData: {
        img: "",
        onclick_link: "",
        status: 1,
        device_type: "",
        id: null,
      },
      errors: {},
    };
  },
  created() {
    this.com_user_type_access([0, 1], true);
    var encryptedData = this.$store.getters.getUser;
    var decodedString = this.com_DecryptString(encryptedData);
    this.userData = JSON.parse(decodedString);
    this.banner_id = this.$route.params.banner_id;
    this.titleName = this.$route.params.name;
    this.id = this.$route.params.id;
    console.log(this.id, "id", "baner_id", this.banner_id);
    if (this.id) {
      const vm = this;
      axios
        .post("/get-banner-image-by-id/", {
          id: vm.id,
        })
        .then((response) => {
          console.log(response, "response");
          if (response.data.status_code === 200) {
            vm.formData = response.data.data;
            vm.formData.status = response.data.data.is_active === 1;
            // vm.alert_message = "Banner image fetched successfully!";
          }
        })
        .catch((error) => {
          console.error("Error fetching banner image:", error);
          this.alert_message =
            "An error occurred while fetching the banner image.";
        });
    }
    // loader.show();
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();
      if (this.fromValidation()) {
        return;
      }
      var rootObject = this;
      this.errors = {};

      var msg = "Are you sure to add this banner image?";
      $.confirm({
        title: "Confirm!",
        content: msg,
        buttons: {
          yes: function () {
            loader.show();
            // Prepare form data for submission
            const submitData = {
              offer_banner_id: rootObject.banner_id,
              img: rootObject.formData.img,
              onclick_link: rootObject.formData.onclick_link,
              device_type: rootObject.formData.device_type,
              is_active: rootObject.formData.status ? 1 : 0,
              id: rootObject.id || null,
            };
            axios
              .post("/add-banner-image", submitData)
              .then(function (response) {
                console.log(response);
                loader.hide();
                // Show success message
                rootObject.alert_message =
                  response.data.message || "Banner image added successfully!";
                // Reset form after successful submission
                rootObject.resetForm();
                rootObject.alert_message = "Banner image added successfully!";
              })
              .catch(function (error) {
                loader.hide();
                let alertmessage = "";
                // Handle validation errors from server
                if (error.response && error.response.data) {
                  if (error.response.data.errors) {
                    // Laravel validation errors format
                    for (var field in error.response.data.errors) {
                      if (error.response.data.errors[field].length > 0) {
                        rootObject.errors[field] =
                          error.response.data.errors[field][0];
                      }
                    }
                  } else {
                    // General error message
                    for (var prop in error.response.data) {
                      alertmessage += " " + error.response.data[prop];
                    }
                    rootObject.alert_message = alertmessage;
                  }
                } else {
                  rootObject.alert_message =
                    "An error occurred while saving the banner image.";
                }
                rootObject.com_errorHandel(error);
              });
          },
          no: function () {
            return;
          },
        },
      });
      // Clear alert message after 5 seconds
      setTimeout(function () {
        rootObject.alert_message = "";
      }, 5000);
    },
    fromValidation() {
      this.errors = {};
      var validationFlag = false;

      // Image URL validation
      try {
        if (!this.formData.img || this.formData.img.trim() === "") {
          this.errors.img = "Please enter image URL";
          validationFlag = true;
        } else {
          // Try to create URL object - will throw error if invalid
          new URL(this.formData.img.trim());
          // If we reach here, URL is valid - clear any previous errors
          this.errors.img = "";
        }
      } catch (error) {
        this.errors.img = "Please enter a valid image URL";
        validationFlag = true;
      }

      // Onclick URL validation
      try {
        if (
          !this.formData.onclick_link ||
          this.formData.onclick_link.trim() === ""
        ) {
          this.errors.onclick_link = "Please enter destination URL";
          validationFlag = true;
        } else {
          // Try to create URL object - will throw error if invalid
          new URL(this.formData.onclick_link.trim());
          // If we reach here, URL is valid - clear any previous errors
          this.errors.onclick_link = "";
        }
      } catch (error) {
        this.errors.onclick_link = "Please enter a valid destination URL";
        validationFlag = true;
      }

      // Platform validation
      if (!this.formData.device_type || this.formData.device_type === "") {
        this.errors.device_type = "Please select platform";
        validationFlag = true;
      } else {
        // Validate if selected value is within allowed options
        const allowedDeviceTypes = ["1", "2", "3", "4"];
        if (
          !allowedDeviceTypes.includes(this.formData.device_type.toString())
        ) {
          this.errors.device_type = "Invalid platform selected";
          validationFlag = true;
        }
      }

      return validationFlag;
    },
    resetForm() {
      this.formData = {
        img: "",
        onclick_link: "",
        device_type: "",
        status: 1,
      };
      this.errors = {};
      this.alert_message = "";

      // Reset form validation state
      if (this.$refs.myForm) {
        this.$refs.myForm.reset();
      }

      // Clear any select2 selections if you're using select2
      if (typeof $ !== "undefined" && $.fn.select2) {
        $("#device_type").val("").trigger("change");
      }
    },
  },
  mounted: function () {
    $(".select2").select2();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.displayhide {
  display: none;
}
</style>
